export default "__VITE_PUBLIC_ASSET__2547e0bd__"